import { Outlet } from 'react-router';

const GalleryRarityLayout = () => {
  return <Outlet />;
};
export default GalleryRarityLayout;
